import { IntentInfo, intentInfoToLocal } from './intent';
import { CompositeInfo, compositeInfoToLocal } from './composite';
import { EntityInfo, entityInfoToLocal } from './entity';
import { ServiceInfo, serviceInfoToLocal } from './service';
import { FakeTypeInfo, fakeTypeInfoToLocal } from './fake-type';

export type Pagination = {
  totalSize: number;
  pageSize: number;
  page: number;
  list: (IntentInfo | CompositeInfo | EntityInfo | ServiceInfo | FakeTypeInfo)[];
};

export function parsePagination(res: any): Pagination {

  const data: Pagination = {
    totalSize: res.total_size,
    pageSize: res.page_size,
    page: res.page,
    list: (res.list || []).map((item: any) => {

      switch (item.__typename) {
        case 'IntentInfo':
          return intentInfoToLocal(item);
        case 'CompositeInfo':
          return compositeInfoToLocal(item);
        case 'EntityInfo':
          return entityInfoToLocal(item);
        case 'ServiceInfo':
          return serviceInfoToLocal(item);
        default:
          return {};
      }
    })
  };

  return data;
}

export function parsePaginationFakeTypes(res: any): Pagination {

  const data: Pagination = {
    totalSize: res.total_size,
    pageSize: res.page_size,
    page: res.page,
    list: (res.list || []).map(fakeTypeInfoToLocal)
  };

  return data;
}
